var $57d383f4db4a897a$exports = {};
$57d383f4db4a897a$exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "loadingMore": `\u{3055}\u{3089}\u{306B}\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`
};


export {$57d383f4db4a897a$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
